import axios, {
    type AxiosInstance,
    type InternalAxiosRequestConfig,
    AxiosError,
    type AxiosResponse,
} from "axios";
import { toast } from "sonner";
import { getCookie, eraseCookie } from "@/utils/cookies";
import { COOKIE_NAMES } from "@/constants/auth";
import { useAuthStore } from "@/store/authStore";
import { isAuthError, isSessionExpired, isSuccess } from "@/utils/statusHelper";

interface ServiceConfig {
    baseURL: string;
    includeToken?: boolean;
    module?: string;
}

export class ApiInterceptor {
    public service: AxiosInstance;

    constructor({ baseURL, includeToken = false, module = "UserAuthentication" }: ServiceConfig) {
        this.service = axios.create({
            baseURL,
            headers: {
                "Content-Type": "application/json",
                // 'Content-Type': 'multipart/form-data',
            }, params: {
                module: module,
            },
        });

        /** REQUEST */
        this.service.interceptors.request.use(
            (config: InternalAxiosRequestConfig) => {
                if (includeToken) {
                    const token = getCookie(COOKIE_NAMES.ACCESS_TOKEN);
                    if (token) {
                        // config.headers.Authorization = `Bearer ${token}`;
                        config.headers.AuthToken = token;
                    }
                }
                return config;
            },
            (error) => Promise.reject(error)
        );

        /** RESPONSE */
        this.service.interceptors.response.use(
            (response: AxiosResponse<any>) => {
                const data = response.data ?? {};
                const statusCode = Number(data?.StatusCode);

                // SESSION FAILED
                if (isSessionExpired(statusCode) || isAuthError(statusCode)) {
                    eraseCookie(COOKIE_NAMES.ACCESS_TOKEN);
                    useAuthStore.getState().logout();
                    toast.error("Session expired. Please login again.");
                    return Promise.reject(new Error("Session expired"));
                }



                // FAILED STATUS
                // if (!isSuccess(statusCode)) {
                //     const msg =
                //         data?.Message || data?.ResponceDataObject?.Message || "Unexpected server error";
                //     return Promise.reject(new Error(msg));
                // }

                // ✔ SUCCESS — DO NOT MODIFY STRUCTURE (KEEP BACKEND SHAPE)
                return response;
            },

            /** NETWORK ERRORS */
            (error: AxiosError) => {
                const msg =
                    (error.response?.data as any)?.Message ||
                    (error.response?.data as any)?.message ||
                    error.message ||
                    "Unexpected server error";
                return Promise.reject(new Error(msg));
            }
        );
    }
}